import { NDATemplate } from 'models/Nda';

export const filterNdaTemplates = (templates: NDATemplate[], id: string) =>
  templates.filter(({ templateId }) => id !== templateId);
